const action_header = "sellerStore/";
// Types
export default {
  GET_SELLER_STORE: action_header + "GET_SELLER_STORE",
  GET_SELLER_STORE_SUCCESS: action_header + "GET_SELLER_STORE_SUCCESS",
  GET_SELLER_STORE_FAILED: action_header + "GET_SELLER_STORE_FAILED",

  CLEAR_SELLER_STORE: action_header + "CLEAR_SELLER_STORE",
};
